// extracted by mini-css-extract-plugin
export default {"container":"style_container__V8Aye","titleSection":"style_titleSection__-prgp"};